import { Row, Col } from 'antd'
import _ from 'lodash'
import Tip from '../../Common/Tip'
import ImageFunctionRow from '../ImageFunctionRow/ImageFunctionRow'
import styles from './ImageFunctionTable.css'

export const ProductsTableHeader = props => {
  const { children } = props

  return (
    <Row
      className={styles.productsTableHeader}
      type='flex'
      justify='space-between'
      align='middle'
    >
      {children}
    </Row>
  )
}

const ImageFunctionTable = props => {
  const {
    readOnly,
    enableSync,
    isNoModelsListing,
    isExtraModel,
    isHiddenCounterOnInvalid,
    defaultShowUploader,
    syncProductImages,
    shareMediaBetweenModels,
    hasDistinctSizesUploader,
    modelsFieldName,
    models,
    // 預設空字串才不會在無屬性、單層表頭出現 undefined
    modelSpecHeader = '',
    itemSpecHeader = '',
    shareImageFieldName,
    syncImageFieldName,
    handleOrderImageChange,
    customColHeaders,
    withCustomCols,
    withProductIdCol = true,
    customCols,
    withCustomProductIdCol,
    customProductIdColHeader,
    customProductIdCol,
    customImageFieldName = 'images'
  } = props

  return (
    <section className={styles.productsTable}>
      <ProductsTableHeader>
        {
          withProductIdCol && (
            withCustomProductIdCol
              ? customProductIdColHeader
              : <Col span={4}> 商品編號</Col>
          )
        }
        {/* 無屬性且沒有自訂欄位 */}
        <Col span={(!withCustomCols && isNoModelsListing && !isExtraModel) ? 16 : 4}>
          {' 商品圖片'}
          <Tip type='info'>(2到10張)</Tip>
        </Col>
        {!withCustomCols && (
          <>
            <Col span={4}>
              <p>{` ${modelSpecHeader}`}</p>
            </Col>
            <Col span={12}>
              {` ${itemSpecHeader}`}
            </Col>
          </>
        )}
        {withCustomCols && customColHeaders}
      </ProductsTableHeader>
      <div className={styles.productsTableBody}>
        {
          models.map(
            (model, idx) => {
              const {
                sku,
                spec,
                name,
                images,
                editable,
                items = [],
                index: modelIndex,
                isSpecSelected
              } = model

              // 商品編號
              const productIds = _.isEmpty(items)
                ? [sku]
                : items.map(({ sku }) => sku)

              const modelSpecValue = _.get(spec, 'selectedValue') || name
              const itemSpecValues = items.map(item => _.get(item, 'spec.selectedValue', ''))

              const activePrimaryImageURL = _.get(images, '[0].url', null)

              const enableShare = hasDistinctSizesUploader && idx === 0 && _.isEmpty(itemSpecValues) && !isNoModelsListing
              const isImageShared = idx !== 0 && shareMediaBetweenModels

              const currentModelField = `${modelsFieldName}[${idx}]`
              const firstOrderImagesFieldName = `${currentModelField}.firstOrderImages`
              const imagesFieldName = `${modelsFieldName}[${isImageShared ? 0 : idx}].${customImageFieldName}`

              const isImageSharedTagContent = editable ? null : '圖片已共用'

              return (
                <ImageFunctionRow
                  // 在修改賣場資訊會把雙層屬性賣場攤平成類似單層不一定每一項單層的 sku 會不同
                  // 所以 key 改成 index 避免 key duplicated
                  key={idx}
                  data-role={`model-image-function-row-${idx}`}
                  // 除了預設 readonly 狀態外
                  // 萬一雙層賣場中有第二層屬性商品的 sku 重複也禁止修改
                  readOnly={readOnly}
                  enableShare={enableShare}
                  enableSync={_.isNil(enableSync) ? isNoModelsListing : enableSync}
                  isImageShared={isImageShared || !editable}
                  isImageSynced={syncProductImages}
                  isImageSharedTagContent={isImageSharedTagContent}
                  isNoModelsListing={isNoModelsListing}
                  isExtraModel={isExtraModel}
                  isHiddenCounterOnInvalid={isHiddenCounterOnInvalid}
                  isSpecSelected={isSpecSelected}
                  defaultShowUploader={defaultShowUploader}
                  hasDistinctSizesUploader={hasDistinctSizesUploader}
                  activePrimaryImageURL={activePrimaryImageURL}
                  currentModelField={currentModelField}
                  firstOrderImagesFieldName={firstOrderImagesFieldName}
                  imagesFieldName={imagesFieldName}
                  shareImageFieldName={shareImageFieldName}
                  syncImageFieldName={syncImageFieldName}
                  modelSpecHeader={modelSpecHeader}
                  itemSpecHeader={itemSpecHeader}
                  modelSpecValue={modelSpecHeader ? modelSpecValue : ''}
                  itemSpecValues={itemSpecValues}
                  productIds={productIds}
                  handleOrderImageChange={handleOrderImageChange}
                  withCustomCols={withCustomCols}
                  withProductIdCol={withProductIdCol}
                  withCustomProductIdCol={withCustomProductIdCol}
                  customCols={customCols}
                  customProductIdCol={customProductIdCol}
                  modelIndex={modelIndex}
                />
              )
            }
          )
        }
      </div>

    </section>
  )
}

export default ImageFunctionTable
